export enum ItemFileMetadataKeys {
  IS_UPLOADED = "isUploaded",
  DATA_URL = "dataURL",
}

